// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import { ReactComponent as SearchIcon } from '../../assets/icons/search.svg';
import { Container } from './styles';

interface SpotilightProps {
  text: string;
}

export function Spotlight({ text }: SpotilightProps) {
  return (
    <Container>
      <figure>
        <SearchIcon />
      </figure>
      <p>{text}</p>
    </Container>
  );
}
